import { createContext, ReactNode, useContext, useState } from "react";

interface INewPlayerShortlistContextType {
    newlyAddedPlayerCount: number;
    setNewlyAddedPlayerCount: React.Dispatch<React.SetStateAction<number>>
}

const NewPlayerShortlistContext = createContext<Partial<INewPlayerShortlistContextType>>({});

export const useNewPlayerShortlistContext = (): INewPlayerShortlistContextType => {
  const context = useContext(NewPlayerShortlistContext);
  if (!context) {
    throw new Error("useNewPlayerShortlistContext must be used within a NewPlayerShortlistContextProvider");
  }
  return context as INewPlayerShortlistContextType;
};

export const NewPlayerShortlistContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [newlyAddedPlayerCount, setNewlyAddedPlayerCount] = useState<number>(0);  
  return (
    <NewPlayerShortlistContext.Provider value={{newlyAddedPlayerCount, setNewlyAddedPlayerCount}}>
      {children}
    </NewPlayerShortlistContext.Provider>
  );
};
